export const initPAModal = (): void => {
  const openBtn = document.getElementById("open-consent-modal");
  const closeBtn = document.getElementById("close-consent-modal");
  const modal = document.getElementById("pa-consent-modal");
  const body = document.body;

  if (!modal || !openBtn || !closeBtn) return;

  const toggleModal = (state: boolean) => {
    modal.classList.toggle("is-open", state);
    modal.setAttribute("aria-hidden", String(!state));
    body.style.overflow = state ? "hidden" : "";
  };

  openBtn.addEventListener("click", (e) => {
    e.preventDefault();
    toggleModal(true);
  });

  closeBtn.addEventListener("click", () => toggleModal(false));

  // Close on overlay click
  modal
    .querySelector(".pa-modal__overlay")
    ?.addEventListener("click", () => toggleModal(false));

  // Close on Escape key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal.classList.contains("is-open")) {
      toggleModal(false);
    }
  });
};
